export const defaultTeam = plan => (plan.team || []).filter(member => member.pending_query_part_ids.length).map(member => member.member_id);
export const selectedTeam = (plan, ids) => (plan?.team || []).filter(member => ids.includes(member.member_id) && member.pending_query_part_ids.length);
export function teamSummary(summary, team, plan) {
  const merged = new Map(summary.map(row => [row.supplier_id, { ...row, team: false }]));
  for (const member of team.filter(row => row.delivery !== 'app')) {
    const previous = merged.get(member.supplier_id), partIds = [...new Set([...(previous?.parts || []).map(part => part.query_part_id), ...member.pending_query_part_ids])];
    merged.set(member.supplier_id, { supplier_id: member.supplier_id, name: member.supplier_name, team: true,
      parts: partIds.map(query_part_id => ({ query_part_id })), partNames: partIds.map(id => plan.parts.find(part => part.query_part_id === id)?.part_name || `Part #${id}`) });
  }
  return [...merged.values()];
}
export function repairTeamPhoneCollision(pairs, ids, plan, supplierIds) {
  const team = selectedTeam(plan, ids).filter(member => member.delivery !== 'app');
  const chosen = new Set([...Object.values(pairs).map(pair => pair.supplier_id), ...team.map(member => member.supplier_id)]);
  const keep = supplierIds.find(id => chosen.has(id));
  return {
    pairs: Object.fromEntries(Object.entries(pairs).filter(([, pair]) => !supplierIds.includes(pair.supplier_id) || pair.supplier_id === keep)),
    ids: ids.filter(id => !team.some(member => member.member_id === id && supplierIds.includes(member.supplier_id) && member.supplier_id !== keep)),
  };
}
